<template>
    <div v-scroll="handleScroll" class="row mx-0">
        <template v-for="(st,n) in itemsToDisplay">
            <div v-if="st" :key="st.id" :class="gridClass || 'col-6 col-md-4 col-lg-3 mb-4 px-2'">
                <product :class="['product-'+ n]"   
                    :product="st" 
                    :scroll="scroll"
                    @open-detail="openProductDetail"
                    @open-zoom="openProductZoom"
                />
            </div>
        </template>

        <!-- Global modal outside card context -->
        <custom-producto 
          :modalp="modalOpen" 
          :producto="selectedProduct" 
          @cerrarModalp="modalOpen = false">
        </custom-producto>

        <!-- Modal Exclusivo de Zoom / Vista Ampliada -->
        <zoom-imagen 
          :modalz="zoomModalOpen" 
          :producto="zoomProducto" 
          :imagenes="zoomImagenes" 
          :scroll="scroll" 
          @cerrarModalz="zoomModalOpen = 0">
        </zoom-imagen>
    </div>
</template>

<script>
import Vue from 'vue';

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})
    import Product from './Product.vue'
    import customProducto from './customProducto.vue'
    import ZoomImagen from './ZoomImagen.vue'
    import { mapState} from 'vuex'

    export default {
        props:['limit', 'items', 'gridClass'],
        name: 'Products',
        components: {
            Product,
            'custom-producto': customProducto,
            'zoom-imagen': ZoomImagen
        },
        data() {
            return {
                data: null,
                sortBy:null,
                id:null, 
                fixed:0,
                scroll:0,
                modalOpen: false,
                selectedProduct: {},
                zoomModalOpen: 0,
                zoomProducto: {},
                zoomImagenes: [],
                dominio: this.$store.state.dominio
            }
        },
        computed : {
            ...mapState(['sliderFilter','filterCat','stock',
            'orderPrice','orderAvailable','orderQuantity','sorted']),
            itemsToDisplay() {
                let list = this.items || this.sorted;
                if (!list) return [];
                if (this.limit) {
                    return list.slice(0, this.limit);
                }
                return list;
            }
        },
        methods: {
             handleScroll: function () {
                this.scroll=window.scrollY
                if (window.scrollY > 80) {
                    this.fixed=1
                }else{
                    this.fixed=0
                }
                
            },
            filterBy(product,n = 1) {
                var flag = true
                if(this.filterCat) {
                    flag = product.idcategoria == this.filterCat
                } 
                if(!(product.precio_venta <= this.sliderFilter[1] && product.precio_venta >= this.sliderFilter[0])) {
                    flag = false
                }
                if(!product.condicion && this.available){
                    flag = false
                }
                if(product.stock > this.stock){
                    flag = false
                }
                
                if(this.limit <=  n ){
                    flag = false
                }
                
                return flag
            },
            openProductDetail(product) {
                this.selectedProduct = product;
                this.modalOpen = true;
            },
            openProductZoom(product) {
                this.zoomProducto = product;
                this.zoomImagenes = (product && product.imagenes) ? product.imagenes : [];
                this.zoomModalOpen = 1;
            }
        },
        mounted() {
            this.id=this.$route.params.id
        }
    }
</script>

<style>
.products{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}
.products .product-card-wrapper {
    /* the product cards themselves handle the shadow */
}
.title-producto{
    margin-bottom: 0;
    font-size: 18px;
}
.productinfo figure{
    margin:0;
}
.datos-producto{
    font-size: 12px;
}

</style>